import { render, staticRenderFns } from "./ListFaqQuestion.vue?vue&type=template&id=230102cc&scoped=true&"
import script from "./ListFaqQuestion.vue?vue&type=script&lang=js&"
export * from "./ListFaqQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230102cc",
  null
  
)

export default component.exports